import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { PhotoPosition } from '../../../../models/trofaco/plantingSiteDetailDto';
import { IsInvalidDirective } from '../../../core/directives/is-invalid.directive';
import { ModalGeneralInformationComponent } from './modal-general-information/modal-general-information/modal-general-information.component';
export class GeneralInformationComponent {
    constructor(partnerService, _modalService, userService) {
        this.partnerService = partnerService;
        this._modalService = _modalService;
        this.userService = userService;
        this.isPDFUpload = false;
        this.isPDFChanged = false;
        this.isPDFFileDelete = false;
        this.pdfErrorSize = false;
        this.isSaving = false;
        this.onSave = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.creatingNew = false;
        this.createNewPartner = (name) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.creatingNew = true;
            let partner = yield this.partnerService.createNgoPartner({ name: name, url: '' });
            this._ngoPartners.push(partner);
            this.creatingNew = false;
            return { ngoPartnerId: partner.ngoPartnerId, partnerName: partner.partnerName, partnerUrl: partner.url };
        });
    }
    get site() {
        return this._site;
    }
    set site(value) {
        this._site = Object.assign({}, value);
    }
    get siteYear() {
        return new Date(this._site.plantingDate).getFullYear();
    }
    set siteYear(value) {
        let date = new Date();
        date.setFullYear(value);
        this._site.plantingDate = date;
    }
    set ngoPartners(value) {
        if (!value) {
            this._ngoPartners = value;
            return;
        }
        this._ngoPartners = value.map(ngo => ({
            ngoPartnerId: ngo.ngoPartnerId,
            partnerName: ngo.partnerName,
            partnerUrl: ngo.url,
            description: ngo.description,
            photo: ngo.photo
        }));
    }
    set saving(isSaving) {
        this.isSaving = isSaving;
    }
    ;
    ngOnInit() {
        this.getCurrentUser();
        let firstYear = 2010;
        let yearToday = new Date().getFullYear();
        this.years = new Array(yearToday - firstYear + 2)
            .fill(0)
            .map((value, index) => index + firstYear).reverse();
        if (this.site.pdfUrl) {
            this.pdfFileName = this.site.pdfUrl.split('/').reverse()[0];
            this.isPDFUpload = true;
            this.isPDFFileDelete = false;
        }
    }
    save() {
        if (this.isInvalidDirectives.some(value => value.isInvalid))
            return;
        this.onSave.emit({ site: this._site, file: this.newHeaderPhoto, LandOWerfile: this._site.newLandOwnerPhoto, pdfFile: { file: this.newPDFFile, isDeleted: this.isPDFFileDelete, isChanged: this.isPDFChanged } });
        this.site.newLandOwnerPhoto = null;
    }
    cancel() {
        this.onCancel.emit();
    }
    onPhotoSelected(photo) {
        this.newHeaderPhoto = photo;
        this.site.photoPosition = PhotoPosition.top;
    }
    onPDFSelected(pdfEvent) {
        this.pdfErrorSize = false;
        this.pdfErrorSize = pdfEvent.target.files[0].size > 100000000;
        if (!this.pdfErrorSize) {
            if (pdfEvent.target.files[0].type === 'application/pdf') {
                this.newPDFFile = pdfEvent.target.files[0];
                this.pdfFileName = this.newPDFFile.name;
                this.isPDFUpload = true;
                this.isPDFChanged = true;
                this.isPDFFileDelete = false;
            }
        }
    }
    onFilePDFDelete() {
        this.isPDFUpload = false;
        this.isPDFChanged = false;
        this.isPDFFileDelete = true;
        this.newPDFFile = null;
        this.pdfErrorSize = false;
    }
    trimAndLower(term, ngo) {
        let pattern = '^' + term.trim().toLowerCase() + '$';
        let matchingRegex = new RegExp(pattern);
        return !!ngo.partnerName.toLowerCase().match(matchingRegex);
    }
    openModal(isLandOwner, isCreate, ngoPartner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.siteModal = Object.assign({}, this.site);
            if (isCreate && isLandOwner) {
                this.resetStage();
            }
            else if (isCreate && !isLandOwner) {
                this.ngoModal = [];
            }
            else {
                this.siteModal = Object.assign({}, this.site);
                if (!isLandOwner) {
                    this.ngoModal = [];
                    this.ngoModal.push(ngoPartner);
                }
            }
            const initialState = {
                site: this.siteModal,
                _ngoPartners: this._ngoPartners,
                isLandOwner: isLandOwner,
                isCreate: isCreate,
                ngoPartner: this.ngoModal
            };
            this.modalRef = this._modalService.show(ModalGeneralInformationComponent, {
                class: "modal-lg",
                initialState,
                keyboard: false,
            });
            this.modalRef.content.isSaved$.subscribe((value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (value) {
                    this.site = {};
                    this.site = Object.assign({}, this.siteModal);
                }
            }));
        });
    }
    deleteLandOwner() {
        this.site.landOwner = "";
        this.site.landOwnerDescription = "";
        this.site.newLandOwnerPhoto = null;
        this.site.landOwnerPhoto = null;
    }
    deletePlantingPartner(ngoId) {
        this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoId), 1);
    }
    resetStage() {
        this.siteModal.landOwner = "";
        this.siteModal.landOwnerDescription = "";
        this.siteModal.newLandOwnerPhoto = null;
        this.siteModal.landOwnerPhoto = null;
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
    toggleBanner() {
        this.site.enabledBanner = !this.site.enabledBanner;
    }
}
